import React from 'react';
import { ActionBadge } from './action-badge';
import { truncateUuid } from './util';

export interface IGuarantorIdBadgeProps {
    className?: string;
    guarantorId: string;
    forceGuarantor?: boolean;
    onCopy?: (url: string) => void;
    onRemove?: () => void;
    openInNewTab?: boolean;
}

export const GuarantorIdBadge: React.FunctionComponent<IGuarantorIdBadgeProps> = (
    props: IGuarantorIdBadgeProps,
): React.ReactElement => {
    const { className, guarantorId, forceGuarantor, onCopy, onRemove, openInNewTab } = props;
    return (
        <ActionBadge
            className={className}
            hideAction={forceGuarantor}
            path={`/guarantors/${guarantorId}`}
            tooltip="View Guarantor"
            onCopy={onCopy}
            onRemove={onRemove}
            openInNewTab={openInNewTab}>
            Guarantor ID – {truncateUuid(guarantorId)}
        </ActionBadge>
    );
};
